// import {Translate} from "react-redux-i18n";
import React from 'react'
import './Spinner.css'
import { getCompanyLogo, getCompanyName } from '../utils/common-utils'

const loadingImage = require('../images/spinner.gif').default
const companyName = getCompanyName()
const loadingMessages = [
  'Have a wonderful trading session!',
  `Thank you for choosing ${companyName}, we appreciate it!`,
  'Please let us know if there are ways to improve your experience!',
  `Thanks for trading with ${companyName}!`,
  `We appreciate the trust you place in ${companyName}!`,
  'With so many choices, we thank you for choosing us!',
]

const loadingBDSwiss = `Your team at ${companyName}`
const selection = Math.floor(Math.random() * loadingMessages.length)

const Spinner = () => {
  const loadingLogo = getCompanyLogo()
  return (
    <div className="loader">
      {loadingLogo}
      <div className="quoteContainer">
        <div className="quote">"{loadingMessages[selection]}"</div>
        <div>- {loadingBDSwiss}</div>
      </div>
      <div className="spinner">
        <img alt="Loading..." src={loadingImage} />
      </div>
    </div>
  )
}

export default Spinner
